import { Content, Portal, Root, Trigger } from '@radix-ui/react-popover';
import type { ReactNode } from 'react';

export function Popover({
  children,
  open,
  onOpenChange,
  trigger,
  onTriggerButtonClick,
}: {
  trigger: ReactNode;
  children: ReactNode;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onTriggerButtonClick: () => void;
}) {
  return (
    <div className="inline-block text-left">
      <Root open={open} onOpenChange={onOpenChange}>
        <Trigger onClick={onTriggerButtonClick} className="relative">
          {trigger}
        </Trigger>
        <Portal>
          <Content
            align="center"
            sideOffset={4}
            className="radix-side-top:animate-slide-up radix-side-bottom:animate-slide-down z-50 w-full rounded-lg bg-gray-1 p-4 shadow-md-down"
          >
            {children}
          </Content>
        </Portal>
      </Root>
    </div>
  );
}
